import { Fragment, useEffect, useRef, useState } from "react";


import { useToastAlert } from 'design-system/Toast';
import { logBehavior } from "../../../Data/Behavior";

import { useSession, useSignIn } from "../../../Recoil/Session/Session";

import { GuideTextBoxForPairedVerification, GuideTextBoxForStandAloneVerification } from "../../../Components/GuideTextBoxs";

import LoadingCircle from "../../../Components/LoadingCircleAnimated";

import { fn, validateEmailForm } from "../../../Functions";
import { verifyEmail, verifyOtp } from "../../../Data/User/Email";

import './Login.scss';
import { useTitles } from "../../../Recoil/Novel/Title";

export type validationStatusType = 'undone' | 'pending' | 'success' | 'fail';

const Login = ({
    email, setEmail, otp, setOtp, redirectTo, token, isInvited

}:{
    email: string, setEmail: (val:string)=>void,
    otp: string, setOtp: (val:string)=>void,
    redirectTo: string, token?: string,
    isInvited: boolean
}) => {
    const {sessionRefresh} = useSession();
    const {EmailTokenSignin} = useSignIn();
    const {toastAlert} = useToastAlert();
    const [isLoading, setIsLoading] = useState(false);
    

    const [ emailValidationStatus, setEmailValidationStatus ] = useState<validationStatusType>('undone');
    const [ isEmailValidating, setIsEmailValidating ] = useState<boolean>(false);


    useEffect(()=>{
        let timer = setTimeout(()=>{
            (async()=>{
                setIsLoading(true);
                if (token){
                    toastAlert("자동 로그인 중입니다.",2000);
                    
                    const res = await EmailTokenSignin(email, token);

                    if (res){
                        logBehavior('login(success)',{});
                        toastAlert("자동 로그인이 성공했습니다.",2000, 'success');

                        await sessionRefresh();

                        fn.goto(redirectTo);
                    }else{
                        toastAlert("인증에 실패했습니다. 다시 확인해주세요.", 2000, 'error');
                    };
                };

                if (email) {
                    setEmail(email);
                };
                setIsLoading(false);
            })();
        },200)

        return ()=>{
            clearTimeout(timer);
        }

    },[EmailTokenSignin, email, redirectTo, sessionRefresh, setEmail, toastAlert, token]);

    return <div className={"Login"}>
        <div className={"LoginInner"} >
            <section className={"Header"} >
                <img 
                    src={"https://static.novela.today/icon/chevron_left_thick.svg"} 
                    alt={"chevron"} width={24} height={24} 
                    onClick={ () => fn.goto("/")}
                />
                <span>MY</span>
            </section>
            <section className={"Body"} >
                <div className={"LoginContainer"} >
                    <div className={"DialogHead"}>
                        <span className={"Maintext"}>{"이메일 인증코드 로그인"}</span>
                    </div>
                    <div className="DialogBody">
                        <div > {"이메일"} </div>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%', gap: '10px'}}>
                            <EmailValidator {...{emailValidationStatus, setEmailValidationStatus, setIsEmailValidating}} />
                        </div>
                    </div>
                </div>
            </section>
            <section className={"Footer"} >
                <div className={"FooterText"}>{"사용 중 불편한 점이나 궁금한 사항이 있으시면"}</div>
                <div className={"FooterText"}>
                    {"언제든 "}    
                    <a href="mailto:help@webtoon.today">{"help@webtoon.today"}</a>
                    {"로 문의주시기 바랍니다."}
                </div>
                

            </section>
            <LoadingCircle show={isLoading || isEmailValidating}/>
        </div>
    </div>;
};


const EmailValidator = ({
    emailValidationStatus, setEmailValidationStatus,
    setIsEmailValidating
}: {
    emailValidationStatus: validationStatusType, setEmailValidationStatus: React.Dispatch<React.SetStateAction<validationStatusType>>,
    setIsEmailValidating: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const { logout, EmailTokenSignin, EmailSignupWithOtp } = useSignIn();

    const { toastAlert } = useToastAlert();
    const { session, sessionRefresh } = useSession();
    const { titleObject, refreshTitle } = useTitles();

    const [ email, setEmail ] = useState<string>(session.email || "");
    const [ otp, setOtp ] = useState<string>("");
    const [ otpValidationStatus, setOtpValidationStatus ] = useState<validationStatusType>('undone');
    const [ isVisibleoOtpForm, setIsVisibleOtpForm ] = useState(false);
    const textBoxMontorTimer: React.MutableRefObject<ReturnType<typeof setTimeout> | null> = useRef(null);


    useEffect(()=>{
        if (session.memberState === 'regular'){
            if (session.email === null){
                logout();
            }else{
                setEmailValidationStatus('success');
                setOtpValidationStatus('success');
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[session])

    return <Fragment>
        <GuideTextBoxForPairedVerification
            purpose={'send'}
            text={email}
            onChange={(event: any) => {
                if (textBoxMontorTimer.current) {
                    clearTimeout(textBoxMontorTimer.current);
                }
                textBoxMontorTimer.current = setTimeout(() => {
                    logBehavior('purchase-enter-email', {});
                }, 300);

                setEmail(event.target.value);
            }}
            placeholder={''}
            isDisabled={emailValidationStatus === 'success' || isVisibleoOtpForm}
            guideTexts={{ success: '인증되었어요.' }}
            validationStatus={emailValidationStatus}
            secondStepValidationStatus={otpValidationStatus}
            onClick={async () => {
                if (!validateEmailForm(email)) {
                    logBehavior('purchase-invalid-email', {});
                    setEmailValidationStatus('fail');
                    return;
                }

                if (isVisibleoOtpForm) {
                    return;
                }

                setIsEmailValidating(true);

                const verifyEmailRes = await verifyEmail(email);
                logBehavior('verify-email', {});

                if (verifyEmailRes) {
                    setIsVisibleOtpForm(true);

                    logBehavior('verify-email(success)', {});
                } else {
                    toastAlert('이메일에 문제가 있어요.', 3000, 'error');
                    logBehavior('verify-email(fail)', {});
                    setEmailValidationStatus('fail');
                }
                setIsEmailValidating(false);
            }}                     
        />
        { isVisibleoOtpForm && <GuideTextBoxForStandAloneVerification
            purpose={'verification'}
            text={otp}
            onChange={(event : any) =>{ setOtp(event.target.value); }}
            placeholder={''}
            guideTexts={{ fail: 'otp 인증에 실패했어요.' }}
            validationStatus={otpValidationStatus}
            onClick={async ()=>{
                setIsEmailValidating(true);
                const emailTokenSigninRes = await EmailTokenSignin(email, otp);
                
                if ( emailTokenSigninRes.email ) {
                    await sessionRefresh();
                    

                    refreshTitle(Object.keys(titleObject).map( key => {
                        const [serviceId, titleId] = key.split(':');
                        return {serviceId, titleId};
                    }));
                    
                    logBehavior('email-token-login(success)', {});
                    setOtpValidationStatus('success');
                    setEmailValidationStatus('success');
                    setIsVisibleOtpForm(false);                                    
                } else {
                    logBehavior('email-token-login(fail)', {});
                    
                    const verifyOtpRes = await verifyOtp(email, otp);
                    
                    if ( verifyOtpRes ) {
                        const name = email.split('@')[0];
                        const emailSignupRes = await EmailSignupWithOtp(email, otp, name);

                        if ( emailSignupRes ) {
                            await sessionRefresh();

                            logBehavior('email-signup-with-otp(success)', {});
                            setOtpValidationStatus('success');
                            setEmailValidationStatus('success');
                            setIsVisibleOtpForm(false);        
                        } else {
                            toastAlert('otp 인증에 실패했어요.', 3000, 'error');
                            logBehavior('email-signup-with-otp(fail)', {});
                            setEmailValidationStatus('undone');
                            setOtpValidationStatus('fail');                                
                        }
                    } else {
                        toastAlert('otp 인증에 실패했어요.', 3000, 'error');
                        logBehavior('verify-otp(fail)', {});
                        setEmailValidationStatus('undone');
                        setOtpValidationStatus('fail');                                
                    }

                }

                setIsEmailValidating(false);
            }}
        />}
    </Fragment>
};
export default Login;